export default "__VITE_ASSET__BXPWnNnO__"